import { defineAsyncComponent } from 'vue'
export default {
  astrobot: defineAsyncComponent(() => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/layouts/astrobot.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/web/wap/releases/20261103-190505-7c5b4a26/vue_src/nuxt/layouts/default.vue").then(m => m.default || m))
}